export default __webpack_public_path__ + "static/media/visa_logo_400x250.cc144d49.jpg";